import { render } from "./OperationsIndex.vue?vue&type=template&id=088cf2ec"
import script from "./OperationsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Operations/OperationsIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "088cf2ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('088cf2ec', __exports__)) {
    api.reload('088cf2ec', __exports__)
  }
  
  module.hot.accept("./OperationsIndex.vue?vue&type=template&id=088cf2ec", () => {
    api.rerender('088cf2ec', render)
  })

}


export default __exports__